module.exports = __webpack_public_path__ + "static/media/plane-black.fa342768.svg";